/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CREATE_COUPON } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateCouponMethods extends IPluginMethodMap {
  getCreateCouponProps(args: any): Promise<any>;
}

export class CreateCouponService implements IAgentPlugin {
  readonly methods: ICreateCouponMethods;

  constructor() {
    this.methods = {
      getCreateCouponProps: this.getCreateCouponProps.bind(this),
    };
  }

  async getCreateCouponProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(args, "Args678900");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: CREATE_COUPON,
          variables: {
            data: {
              ...args,
            },
          },
          fetchPolicy: "no-cache",
        });
        console.log("Create Coupon final data", res?.data);
        console.log(
          "Create Coupon final data in xyuuh",
          res?.data?.createDiscount
        );
        return res?.data?.createDiscount;
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
